export default class Wysiwyg extends HTMLElement {
    constructor(m) {
        super(m);

        // UI
        this.$content = this.querySelector('[data-content]');
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.removeExtremeMargins();
    }

    disconnectedCallback() {}

    // =============================================================================
    // Methods
    // =============================================================================
    removeExtremeMargins() {
        if (this.$content) {
            if (this.$content.children.length) {
                const $firstElement = this.$content.children[0];
                const $lastElement = this.$content.children[this.$content.children.length - 1];
                $firstElement.classList.add('c-wysiwyg_first');
                $lastElement.classList.add('c-wysiwyg_last');
            }
        }
    }
}
